import { render, staticRenderFns } from "./KeyboardSlideResultNotCompatible.vue?vue&type=template&id=25cd2000&scoped=true"
import script from "./KeyboardSlideResultNotCompatible.vue?vue&type=script&lang=ts"
export * from "./KeyboardSlideResultNotCompatible.vue?vue&type=script&lang=ts"
import style0 from "./KeyboardSlideResultNotCompatible.vue?vue&type=style&index=0&id=25cd2000&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25cd2000",
  null
  
)

export default component.exports
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QImg from 'quasar/src/components/img/QImg.js';
import qInstall from "../../../../../node_modules/@quasar/app/lib/webpack/runtime.auto-import.js";
qInstall(component, 'components', {QBtn,QImg});
